import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { API } from "@/lib/api";

export function useAiStream() {
  const { getToken } = useAuth();
  return useCallback(
    async (path, body, onText) => {
      const token = await getToken();
      let res;
      try {
        res = await fetch(`${API}${path}`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(body ?? {}),
        });
      } catch {
        throw new Error("Geen verbinding met de server. Controleer je internet.");
      }
      if (!res.ok) {
        let detail;
        try {
          detail = (await res.json()).detail;
        } catch {}
        throw new Error(typeof detail === "string" ? detail : "De AI is nu niet beschikbaar. Probeer het later opnieuw.");
      }
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      let full = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          if (!p.startsWith("data: ")) continue;
          const ev = JSON.parse(p.slice(6));
          if (ev.error) throw new Error(ev.error);
          if (ev.delta) {
            full += ev.delta;
            onText(full);
          }
        }
      }
      return full;
    },
    [getToken]
  );
}
